import { Input } from '@web/utils';
import { OrderDelivery, Silo } from '../types';

type PSilo = Pick<Silo, 'id' | 'name'>;

interface SiloFormProps {
  delivery: OrderDelivery;
  changeDeliverySilo: (siloId: string) => void;
  handleSiloDateUpdate: (
    delivery: OrderDelivery,
    key: string,
    value: string | number,
  ) => void;
  silos: PSilo[];
  t: any;
}

const SingleDeliverySiloForm: React.FC<SiloFormProps> = (props) => {
  const { delivery, changeDeliverySilo, handleSiloDateUpdate, t, silos } =
    props;

  const handleDeliveryDateChange = (key: string, value: string | number) => {
    if (!value) return;
    handleSiloDateUpdate(delivery, key, value);
  };

  return (
    <>
      {delivery.siloID && (
        <div className="w-full  flex items-end justify-between">
          <div className="w-full max-w-30-0">
            <p className="mb-0-6 text-2-0 md:text-1-2 leading-1-33 font-li">
              {t('checkout.choose_silo')}
            </p>
            <select
              className="w-full rounded-8-0 p-1-0 border-secondary-grey text-body1 leading-1-25 border bg-white"
              data-testid={`delivery-silo-${delivery.id}`}
              value={delivery.siloID || 1}
              onChange={(e) => changeDeliverySilo(e.target.value)}
            >
              {silos.map((silo) => (
                <option key={silo.id} value={silo.id}>
                  {silo.name}
                </option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-1-0">
            <Input
              label={t('checkout.delivery_from') || ''}
              id="from"
              type="date"
              data-testid="silo-input-from"
              defaultValue={delivery.deliveryFrom ?? ''}
              onChange={handleDeliveryDateChange}
            />
            <Input
              label={t('checkout.delivery_to') || ''}
              id="to"
              type="date"
              data-testid="silo-input-to"
              defaultValue={delivery.deliveryTo ?? ''}
              onChange={handleDeliveryDateChange}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default SingleDeliverySiloForm;
